<template>
  <div class="animated revealUp dynamic-voucher-layout">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $route.params["dv_id"] ? "Edit" : "Add" }} Dynamic Voucher
      </div>
    </div>
    <div class="white-wrapper">
      <div class="d-flex align-items-center justify-content-between">
        <p class="text-left text-blue font-weight-bold my-1">
          Dynamic Voucher Settings
        </p>
        <div>
          <b-form-checkbox
            class="j-checkbox pb-0 ml-3"
            v-model="dynamicVoucherSettings.dv_is_active"
            unchecked-value="N"
            value="Y"
            ><span
              :class="`${
                dynamicVoucherSettings.dv_is_active == 'Y'
                  ? 'text-blue'
                  : 'text-danger'
              } font-weight-bold`"
              >{{
                dynamicVoucherSettings.dv_is_active == "Y"
                  ? "Active"
                  : "Inactive"
              }}</span
            ></b-form-checkbox
          >
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">Applicable Vouchers</label>
          <div class="dropdown-curve-container">
            <div class>
              <multiselect
                v-model="dynamicVoucherSettings.dv_os_id"
                placeholder=""
                id="dv_os_id"
                name="dv_os_id"
                :options="validDynamicVouchers"
                label="offer_title"
                track-by="os_id"
                :multiple="false"
                v-validate="'required'"
              >
              </multiselect>
            </div>
            <p v-if="submitted && errors.has('dv_os_id')" class="error_message">
              <span>{{ errors.first("dv_os_id") }}</span>
            </p>
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">Voucher Title</label>
          <div class="input-material">
            <input
              placeholder="."
              type="text"
              v-model="dynamicVoucherSettings.dv_title"
              name="dv_title"
              id="dv_title"
              v-validate="'required'"
            />
          </div>
          <p v-if="submitted && errors.has('dv_title')" class="error_message">
            <span>{{ errors.first("dv_title") }}</span>
          </p>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">Minimum Transaction Value</label>
          <div class="input-material">
            <input
              placeholder="."
              type="number"
              min="0"
              v-model.number="dynamicVoucherSettings.dv_min_value"
              name="dv_min_value"
              id="dv_min_value"
              v-validate="'required'"
            />
          </div>
          <p
            v-if="submitted && errors.has('dv_min_value')"
            class="error_message"
          >
            <span>Min. value should be a number</span>
          </p>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">Priority</label>
          <div class="input-material">
            <input
              placeholder="."
              type="text"
              v-model="dynamicVoucherSettings.dv_priority"
              name="dv_priority"
              id="dv_priority"
              v-validate="'required'"
            />
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">{{ $t("startdate") }}</label>
          <div class="input-material">
            <div class="add-datepicker custom-date">
              <div class="d-flex align-items-center">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="dynamicVoucherSettings.dv_validity_start_date"
                  type="date"
                  class="theme-custom-date-time w-100"
                  typeable
                  id="dv_start_date"
                  name="dv_start_date"
                  v-b-tooltip.hover
                  :title="$t('start_date_tooltip')"
                >
                </Datepicker>
                <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">Start Time</label>
          <div class="input-material">
            <input
              placeholder="."
              type="time"
              v-model="dynamicVoucherSettings.dv_validity_start_time"
              name="dv_title"
              id="dv_title"
              v-validate="'required'"
            />
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">{{ $t("enddate") }}</label>
          <div class="input-material">
            <div class="add-datepicker custom-date">
              <div class="d-flex align-items-center">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="dynamicVoucherSettings.dv_validity_end_date"
                  type="date"
                  class="theme-custom-date-time w-100"
                  typeable
                  id="dv_start_date"
                  name="dv_start_date"
                  v-b-tooltip.hover
                  :title="$t('start_date_tooltip')"
                >
                </Datepicker>
                <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">End Time</label>
          <div class="input-material">
            <input
              placeholder="."
              type="time"
              v-model="dynamicVoucherSettings.dv_validity_end_time"
              name="dv_title"
              id="dv_title"
              v-validate="'required'"
            />
          </div>
        </div>

        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">Applicable on</label>
          <div class="dropdown-curve-container">
            <div class>
              <multiselect
                v-model="dynamicVoucherSettings.dv_rule_id"
                placeholder=""
                id="dv_rule_id"
                name="dv_rule_id"
                :options="masterRules"
                label="label"
                track-by="value"
                :multiple="false"
                v-validate="'required'"
                @select="handleRuleSelection($event)"
              >
              </multiselect>
            </div>
            <p
              v-if="submitted && errors.has('dv_rule_id')"
              class="error_message"
            >
              <span>{{ errors.first("dv_rule_id") }}</span>
            </p>
          </div>
        </div>

        <div class="col-12 col-md-4 col-xl-3">
          <label class="my-1">Code Valid From</label>
          <div class="row mt-1">
            <div class="col-6">
              <b-form-radio
                value="transaction_date"
                class="j-radio ml-2 pb-0"
                v-model="dynamicVoucherMetaData.validity"
              >
                <div>
                  <span>Transaction Date</span>
                </div>
              </b-form-radio>
            </div>
            <div class="col-6">
              <b-form-radio
                v-if="
                  dynamicVoucherSettings.dv_rule_id &&
                  (dynamicVoucherSettings.dv_rule_id['value'] == 1 ||
                    dynamicVoucherSettings.dv_rule_id['value'] == 3)
                "
                value="show_date"
                class="j-radio ml-2 pb-0"
                v-model="dynamicVoucherMetaData.validity"
              >
                <div>
                  <span>Show Date</span>
                </div>
              </b-form-radio>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <div class="row">
            <div class="col-12 col-md-6">
              <label class="my-1">Max. Codes</label>
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="dynamicVoucherSettings.dv_max_codes"
                  name="dv_max_codes"
                  id="dv_max_codes"
                  v-validate="'required'"
                />
              </div>
              <p
                v-if="submitted && errors.has('dv_max_codes')"
                class="error_message"
              >
                <span
                  >Max codes should be a number and value should be greater than
                  0</span
                >
              </p>
            </div>
            <div class="col-12 col-md-6">
              <label class="my-1">Code Validity(in days)</label>
              <div class="input-material">
                <input
                  placeholder="."
                  type="number"
                  min="1"
                  v-model="dynamicVoucherSettings.dv_code_validity"
                  name="dv_code_validity"
                  id="dv_code_validity"
                  v-validate="'required'"
                />
                <p
                  v-if="submitted && errors.has('dv_code_validity')"
                  class="error_message"
                >
                  <span
                    >Code validity should be a number and value should be
                    greater than 0</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-12 col-md-4 col-xl-3"
          v-if="
            dynamicVoucherSettings.dv_rule_id &&
            (dynamicVoucherSettings.dv_rule_id['value'] != 2 ||
              dynamicVoucherSettings.dv_rule_id['value'] != 4)
          "
        >
          <label class="my-2"></label>
          <b-form-checkbox
            class="j-checkbox pb-0 ml-3"
            v-model="dynamicVoucherSettings.dv_is_per_ticket"
            unchecked-value="N"
            value="Y"
            >Generate Code Per Seat</b-form-checkbox
          >
        </div>
        <div class="col-12 col-md-4 col-xl-3" v-if="false">
          <label class="my-1">Redemption outlets</label>
          <div class="dropdown-curve-container">
            <div class>
              <multiselect
                v-model="dynamicVoucherSettings.dv_redemptions"
                :close-on-select="false"
                placeholder=""
                id="dv_redemptions"
                name="dv_redemptions"
                :options="masterRedemptionOutlets"
                label="user_name"
                track-by="user_id"
                :multiple="true"
                :limit="1"
                :limit-text="(count) => `& +${count} More`"
                v-validate="'required'"
              >
              </multiselect>
            </div>
            <p
              v-if="submitted && errors.has('dv_redemptions')"
              class="error_message"
            >
              <span>{{ errors.first("dv_redemptions") }}</span>
            </p>
          </div>
        </div>
      </div>
      <div
        class="my-2"
        v-if="
          dynamicVoucherSettings.dv_rule_id &&
          dynamicVoucherSettings.dv_rule_id['value'] != 2
        "
      >
        <p class="text-left text-blue font-weight-bold my-1">Movie Settings</p>
        <div class="row align-items-center">
          <div class="col-12 col-md-4 col-xl-3">
            <label class="mb-1">Formats Applicable</label>
            <div class="dropdown-curve-container">
              <div class>
                <multiselect
                  v-model="dynamicVoucherMovieSettings.mf_id"
                  :close-on-select="false"
                  placeholder=""
                  id="mf_id"
                  name="mf_id"
                  :options="masterFormats"
                  label="mf_name"
                  track-by="mf_id"
                  :multiple="true"
                  :limit="1"
                  :limit-text="(count) => `& +${count} More`"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-xl-3">
            <label class="mb-1">
              Movies
              {{
                dynamicVoucherMovieSettings.is_applicable == "Y"
                  ? "Applicable"
                  : "Not Applicable"
              }}
            </label>
            <div class="dropdown-curve-container">
              <div class>
                <multiselect
                  v-model="dynamicVoucherMovieSettings.md_id"
                  :close-on-select="false"
                  placeholder=""
                  id="md_id"
                  name="md_id"
                  :options="masterMovies"
                  label="movie"
                  track-by="md_id"
                  :multiple="true"
                  :limit="1"
                  :limit-text="(count) => `& +${count} More`"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-xl-3">
            <label class="my-1"></label>
            <b-form-checkbox
              class="j-checkbox pb-0 ml-3"
              v-model="dynamicVoucherMovieSettings.is_applicable"
              unchecked-value="N"
              value="Y"
              >Applicable</b-form-checkbox
            >
          </div>
        </div>
      </div>
      <div
        class="my-2"
        v-if="
          dynamicVoucherSettings.dv_rule_id &&
          dynamicVoucherSettings.dv_rule_id['value'] != 2
        "
      >
        <p class="text-left text-blue font-weight-bold my-1">Cinema Settings</p>
        <table
          class="swc-report-table"
          border="1"
          style="table-layout: auto; background: white; zoom: 0.9"
        >
          <tbody>
            <tr class="bg-lightprimary">
              <td>Cinemas</td>
              <td>Rate Card Groups</td>
              <td>Screens</td>
              <td>Seat Groups</td>
              <td>Ticket Types</td>
              <td>Remove</td>
            </tr>
            <tr
              v-for="(
                cinemaSetting, cinemaSettingIndex
              ) in dynamicVoucherCinemaSettings"
              :key="cinemaSettingIndex"
            >
              <td class="text-center p-0 cinema-settings">
                <multiselect
                  v-model="cinemaSetting.cinema_id"
                  placeholder="Cinema"
                  :close-on-select="false"
                  :options="cinemaSetting.cinemas"
                  label="cine_name"
                  track-by="cine_id"
                  :multiple="true"
                  select-label="Select"
                  deselect-label="Remove"
                  :limit="1"
                  :limit-text="(count) => `& +${count} More`"
                  @select="addCinema($event, cinemaSettingIndex)"
                  @remove="removeCinema($event, cinemaSettingIndex)"
                >
                </multiselect>
              </td>
              <td class="text-center p-0 cinema-settings">
                <multiselect
                  v-model="cinemaSetting.rc_g_id"
                  placeholder="Rate Card Group"
                  :close-on-select="false"
                  :options="cinemaSetting.rate_card_groups"
                  label="rc_g_name"
                  track-by="rc_g_id"
                  :multiple="true"
                  select-label="Select"
                  deselect-label="Remove"
                  :limit="1"
                  :limit-text="(count) => `& +${count} More`"
                >
                </multiselect>
              </td>
              <td class="text-center p-0 cinema-settings">
                <multiselect
                  v-model="cinemaSetting.screen_id"
                  :options="cinemaSetting.screens"
                  :close-on-select="false"
                  select-label="Select"
                  deselect-label="Remove"
                  group-values="screenData"
                  :multiple="true"
                  group-label="cine_name"
                  :group-select="true"
                  label="screen_name"
                  placeholder="Screens"
                  track-by="screen_id"
                  :limit="1"
                  :limit-text="(count) => `& +${count} More`"
                >
                </multiselect>
              </td>
              <td class="text-center p-0 cinema-settings">
                <multiselect
                  v-model="cinemaSetting.seat_group_id"
                  placeholder="Seats"
                  :close-on-select="false"
                  :options="masterSeatGroups"
                  label="sstg_name"
                  track-by="sstg_id"
                  :multiple="true"
                  deselect-label=""
                  :limit="1"
                  :limit-text="(count) => `& +${count} More`"
                >
                </multiselect>
              </td>
              <td class="text-center p-0 cinema-settings">
                <multiselect
                  v-model="cinemaSetting.ticket_type_id"
                  placeholder="Tickets"
                  :close-on-select="false"
                  :options="masterTicketTypes"
                  label="tt_name"
                  track-by="tt_id"
                  :multiple="true"
                  deselect-label=""
                  :limit="1"
                  :limit-text="(count) => `& +${count} More`"
                >
                </multiselect>
              </td>
              <td class="text-center p-0">
                <div
                  class="icon-sm-minus blue-icon ml-2 btn"
                  v-if="cinemaSettingIndex > 0"
                  @click="removeCinemaSetting($event, cinemaSettingIndex)"
                ></div>
              </td>
            </tr>
            <tr
              v-if="
                dynamicVoucherCinemaSettings[
                  dynamicVoucherCinemaSettings.length - 1
                ]['cinema_id'].length
              "
            >
              <td colspan="6">
                <button class="btn-sm add-btn" @click="addCinemaSetting">
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="24"
                    width="24"
                  />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="my-2"
        v-if="
          dynamicVoucherSettings.dv_rule_id &&
          dynamicVoucherSettings.dv_rule_id['value'] != 1
        "
      >
        <p class="text-left text-blue font-weight-bold my-1">FnB Settings</p>
        <div class="row">
          <div class="col-4">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="dynamicVoucherFnbSettings.cinema_id"
                placeholder="Cinema"
                :close-on-select="false"
                :options="masterCinemas"
                label="cine_name"
                track-by="cine_id"
                :multiple="true"
                select-label="Select"
                deselect-label="Remove"
                :limit="1"
                :limit-text="(count) => `& +${count} More`"
              >
              </multiselect>
            </div>
          </div>
          <div class="col-4">
            <div class="dropdown-curve-container">
              <div class>
                <multiselect
                  v-model="dynamicVoucherFnbSettings.fnb_items"
                  :options="categoryWiseFnbItems"
                  :close-on-select="false"
                  select-label="Select"
                  deselect-label="Remove"
                  group-values="fnbItems"
                  :multiple="true"
                  group-label="fc_category"
                  :group-select="true"
                  label="item_name"
                  placeholder="FnB items"
                  track-by="item_code"
                  :limit="1"
                  :limit-text="(count) => `& +${count} More`"
                >
                </multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="my-2">
        <p class="text-left text-blue font-weight-bold my-1">
          Terms And Conditions
        </p>
        <vue-editor
          v-model="dynamicVoucherTermsConditions"
          name="page"
          id="page"
        ></vue-editor>
      </div>
      <div class="d-flex align-items-center justify-content-center my-2">
        <button class="btn-blue btn-sm" @click="onSubmit">Submit</button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import MarketingService from "../../../../services/MarketingService";
import MasterService from "../../../../services/MasterService";
import MovieService from "../../../../services/MovieService";
import CinemasService from "@/services/CinemasService";
import _ from "lodash";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      dynamicVoucherSettings: {
        dv_title: "",
        dv_os_id: "",
        dv_rule_id: 1,
        dv_validity_start_date: moment().format("YYYY-MM-DD"),
        dv_validity_start_time: "06:00",
        dv_validity_end_date: moment().add(1, "day").format("YYYY-MM-DD"),
        dv_validity_end_time: "05:59",
        dv_max_codes: 1,
        dv_priority: 1,
        dv_is_active: "Y",
        dv_code_validity: 1,
        dv_redemptions: "",
        dv_min_value: 0,
        dv_is_per_ticket: "N",
        dv_valid_from_show_date: "N",
        dv_is_active: "Y",
      },
      dynamicVoucherMetaData: { validity: "transaction_date" },
      dynamicVoucherMovieSettings: {
        mf_id: [],
        is_applicable: "Y",
        md_id: [],
      },
      dynamicVoucherCinemaSettings: [
        {
          cinemas: [],
          screens: [],
          rate_card_groups: [],
          rc_g_id: [],
          cinema_id: [],
          screen_id: [],
          seat_group_id: [],
          ticket_type_id: [],
        },
      ],
      dynamicVoucherFnbSettings: {
        cinema_id: [],
        fnb_items: [],
      },
      dynamicVoucherTermsConditions: "",
      validDynamicVouchers: [],
      masterRules: [
        { value: 1, label: "BO" },
        { value: 2, label: "FnB" },
        { value: 3, label: "BO+FnB" },
        { value: 4, label: "All" },
      ],
      masterCinemas: [],
      masterScreens: [],
      masterRateCardGroups: [],
      masterSeatGroups: [],
      masterTicketTypes: [],
      cinemaWiseScreens: [],
      cinemaWiseRateCardGroups: [],
      masterFormats: [],
      masterMovies: [],
      masterRedemptionOutlets: [],
      masterFnbItems: [],
      categoryWiseFnbItems: [],
      submitted: false,
    };
  },
  beforeMount() {
    this.prefetchData();
  },
  methods: {
    prefetchData: async function () {
      await Promise.all([
        this.fetchValidVouchers(),
        this.fetchCinemaWiseScreens(),
        this.fetchSeatGroups(),
        this.fetchTicketType(),
        this.fetchFormats(),
        this.fetchMovies(),
        this.fetchRedemptionOutlets(),
        this.fetchFnbItems(),
        this.fetchCinemaRateCardGroups(),
      ]);
      const dvId = this.$route.params["dv_id"];
      if (dvId) {
        await this.fetchDynamicVoucherDetails(dvId);
      }
    },
    decodeHtml(html) {
      if (!html) return "";

      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    fetchValidVouchers: async function () {
      try {
        const response = await MarketingService.fetchValidDynamicVouchers();
        const { data } = response || {};
        if (!data || !data.status || !data.Records) {
          return this.$toasted.show("No valid vouchers found");
        }

        this.validDynamicVouchers = data.Records;
      } catch (error) {
        console.log(error);
      }
    },
    fetchCinemaWiseScreens: async function () {
      try {
        const response = await MarketingService.getCinemawiseScreenList();
        const { data } = response || {};
        this.cinemaWiseScreens = data.Records;
        if (data.Records) {
          data.Records.forEach((cinema) => {
            this.masterCinemas.push({
              cine_id: String(cinema.cinema_id),
              cine_name: cinema.cine_name,
            });
            cinema.screenData.forEach((screen) => {
              screen["screen_id"] = String(screen.screen_id);
              screen["cinema_id"] = String(screen.cinema_id);
              this.masterScreens.push({
                cine_id: String(cinema.cinema_id),
                screen_id: String(screen.screen_id),
                screen_name: screen.screen_name,
                cine_name: cinema.cine_name,
              });
            });
          });
          if (!this.dynamicVoucherCinemaSettings[0].cinemas.length) {
            this.dynamicVoucherCinemaSettings[0].cinemas.push(
              ...this.masterCinemas
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    fetchSeatGroups: async function () {
      try {
        let loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_screen_seat_type_group",
          sstg_is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterSeatGroups = [...data.Records];
          loader.hide();
        } else {
          console.log("show error:", data.message);
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    fetchTicketType: async function () {
      try {
        let loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_ticket_type",
          tt_is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterTicketTypes = [...data.Records];
          loader.hide();
        } else {
          console.log("show error:", data.message);
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    fetchFormats: async function () {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "ms_movie_formats",
          mf_is_active: "Y",
          orderBy: "asc",
          columnName: "mf_order",
        });

        const { data } = response;
        if (!data.status || !data.Records.length) return;

        this.masterFormats = data.Records;
      } catch (error) {
        console.log(error);
      }
    },
    fetchMovies: async function () {
      try {
        const response = await MovieService.GetActiveMoviesWithFormat({
          movieversions: "Y",
        });

        const { data } = response;
        if (!data.status || !data.Records.length) return;
        this.masterMovies = data.Records;
      } catch (error) {
        console.log(error);
      }
    },
    fetchCinemaRateCardGroups: async function () {
      try {
        let payload = {
          is_private_rate_card: "Y",
          filter_is_active: "Y",
        };
        this.RateCardGroup = [];
        const response = await CinemasService.GetRateCardGroup(payload);
        const { data } = response;

        if (data.status && data.Records && data.Records.length) {
          this.cinemaWiseRateCardGroups = data.Records.reduce(
            (acc, rateCardGroup) => {
              if (!acc[rateCardGroup.cinema_id]) {
                acc[rateCardGroup.cinema_id] = [];
              }
              acc[rateCardGroup.cinema_id].push({
                rc_g_id: rateCardGroup.rc_g_id,
                rc_g_name: rateCardGroup.rc_g_name,
              });
              return acc;
            },
            {}
          );
          return;
        }

        this.$toasted.show("No rate card groups found");
      } catch (error) {
        console.log(error);
      }
    },
    fetchRedemptionOutlets: async function () {
      try {
        const response = await MarketingService.GETUSERLIST();

        const { data } = response;
        if (!data.status || !data.Records) {
          return;
        }
        this.masterRedemptionOutlets = data.Records;
      } catch (error) {
        this._CatchError(error);
      }
    },
    fetchFnbItems: async function () {
      try {
        const response =
          await MarketingService.getFnbItemsForFnbDiscountsOfferType();
        const { data } = response;
        if (!data || !data.status || !data.Records.length) {
          return this.$toasted.show("No fnb items found");
        }

        this.masterFnbItems = data.Records;
        this.categoryWiseFnbItems = Object.values(
          data.Records.reduce((acc, fnbItem) => {
            if (!acc[fnbItem.fc_id]) {
              acc[fnbItem["fc_id"]] = {
                fc_id: fnbItem["fc_id"],
                fc_category: fnbItem["fc_category"],
                fnbItems: [],
              };
            }

            acc[fnbItem["fc_id"]]["fnbItems"].push({
              item_name: fnbItem["item_name"],
              item_code: fnbItem["item_code"],
            });

            return acc;
          }, {})
        );
      } catch (error) {
        this._CatchError(error);
      }
    },
    addCinemaSetting() {
      const selectedCinemas = this.dynamicVoucherCinemaSettings.flatMap(
        (cinemaSetting) => {
          return cinemaSetting.cinema_id.map((cinema) => {
            return String(cinema.cine_id);
          });
        }
      );
      console.log({ selectedCinemas, masterCinemas: this.masterCinemas });
      this.dynamicVoucherCinemaSettings.push({
        cinemas: this.masterCinemas.filter((cinema) => {
          return !selectedCinemas.includes(cinema.cine_id);
        }),
        screens: [],
        rate_card_groups: [],
        rc_g_id: [],
        seat_groups: [],
        ticket_types: [],
        cinema_id: [],
        screen_id: [],
        seat_group_id: [],
        ticket_type_id: [],
      });
    },
    removeCinema(event, index) {
      console.log({ action: "remove cinema", event, index });

      this.dynamicVoucherCinemaSettings[index]["screens"] =
        this.dynamicVoucherCinemaSettings[index]["screens"].filter((screen) => {
          return screen.cinema_id != event.cine_id;
        });
      this.dynamicVoucherCinemaSettings[index]["screen_id"] =
        this.dynamicVoucherCinemaSettings[index]["screen_id"].filter(
          (selectedScreen) => {
            return selectedScreen.cinema_id != event.cine_id;
          }
        );
      // add the removed cinema back to all other rows except the currnt one as it already contains that cinema
      this.dynamicVoucherCinemaSettings.map((setting, settingIndex) => {
        if (settingIndex != index) {
          setting.cinemas = _.uniqBy([...setting.cinemas, event], "cine_id");
        }
      });
    },
    addCinema(event, index) {
      console.log({
        action: "add cinema",
        event,
        index,
        screens: this.masterScreens,
      });
      const currentRowSelectedCinemas = [
        ...this.dynamicVoucherCinemaSettings[index]["cinema_id"].map(
          (cinema) => {
            return cinema.cine_id;
          }
        ),
        event.cine_id,
      ];
      this.dynamicVoucherCinemaSettings[index]["screens"] =
        this.cinemaWiseScreens.filter((cinema) => {
          return currentRowSelectedCinemas.includes(String(cinema.cinema_id));
        });
      this.dynamicVoucherCinemaSettings[index]["rate_card_groups"].push(
        ...this.cinemaWiseRateCardGroups[event.cine_id]
      );

      this.dynamicVoucherCinemaSettings.map((setting, settingIndex) => {
        if (settingIndex != index) {
          setting.cinemas = setting.cinemas.filter((cinema) => {
            return cinema.cine_id != event.cine_id;
          });
        }
      });
    },
    removeCinemaSetting(event, index) {
      // add the selected cinema id in the current row if any, to the other rows for selection
      // if(this.dynamicVoucherCinemaSettings.cinema)
      console.log({
        event,
        index,
        cinema: this.dynamicVoucherCinemaSettings[index],
      });

      this.dynamicVoucherCinemaSettings.forEach(
        (cinemaSetting, cinemaSettingIndex) => {
          if (cinemaSettingIndex != index) {
            cinemaSetting.cinemas = _.uniqBy(
              [
                ...cinemaSetting.cinemas,
                ...this.dynamicVoucherCinemaSettings[index]["cinema_id"],
              ],
              "cine_id"
            );
          }
        }
      );
      this.dynamicVoucherCinemaSettings.splice(index, 1);
    },
    handleRuleSelection(event) {
      if (event.value == 1) {
        this.dynamicVoucherFnbSettings = {
          cinema_id: [],
          fnb_items: [],
        };
      } else if (event.value == 2) {
        if (
          this.dynamicVoucherCinemaSettings &&
          this.dynamicVoucherCinemaSettings.length &&
          this.dynamicVoucherCinemaSettings[0]
        ) {
          this.dynamicVoucherCinemaSettings = [
            {
              ...this.dynamicVoucherCinemaSettings[0],
              dv_is_per_ticket: "N",
              dv_valid_from_show_date: "N",
              rate_card_groups: [],
              rc_g_id: [],
              cinema_id: [],
              screen_id: [],
              seat_group_id: [],
              ticket_type_id: [],
            },
          ];
        } else {
          this.dynamicVoucherCinemaSettings = [
            {
              cinemas: [],
              screens: [],
              rate_card_groups: [],
              rc_g_id: [],
              cinema_id: [],
              screen_id: [],
              seat_group_id: [],
              ticket_type_id: [],
            },
          ];
        }
      }
    },
    onSubmit: async function () {
      let loader = this.$loading.show();
      try {
        this.submitted = true;
        console.log(
          this.dynamicVoucherMetaData["validity"],
          "validity on",
          this.dynamicVoucherSettings,
          this.dynamicVoucherTermsConditions
        );
        const payload = {
          ...this.dynamicVoucherSettings,
          dv_rule_id: this.dynamicVoucherSettings["dv_rule_id"]["value"],
          dv_validity_start: `${moment(
            this.dynamicVoucherSettings.dv_validity_start_date
          ).format("YYYY-MM-DD")} ${moment(
            this.dynamicVoucherSettings.dv_validity_start_time,
            "HH:mm"
          ).format("HH:mm")}`,
          dv_validity_end: `${moment(
            this.dynamicVoucherSettings.dv_validity_end_date
          ).format("YYYY-MM-DD")} ${moment(
            this.dynamicVoucherSettings.dv_validity_end_time,
            "HH:mm"
          ).format("HH:mm")}`,
          dv_os_id: this.dynamicVoucherSettings["dv_os_id"]["os_id"],
          dv_movie_formats: null,
          dv_movie_is_applicable:
            this.dynamicVoucherMovieSettings.is_applicable || "Y",
          dv_valid_from_show_date:
            this.dynamicVoucherMetaData["validity"] == "show_date" ? "Y" : "N",
          cinemaSettings: [],
          movieSettings: [],
          dv_terms_conditions: String(this.dynamicVoucherTermsConditions),
          dv_redemptions: "",
        };
        const isInputsValid = await this.$validator.validate();
        console.log({
          dynamicVoucherSettings: this.dynamicVoucherMovieSettings,
        });
        if (!isInputsValid) {
          return;
        }
        console.log(
          this.dynamicVoucherCinemaSettings,
          "this.dynamicVoucherCinemaSettings"
        );
        if (this.dynamicVoucherCinemaSettings[0]["cinema_id"].length) {
          // for each screen related to a cinema, generate a single row with cinema id, screen id. As seat groupps and ticket types are master they can be inserted as string[] in database for each screen rows
          this.dynamicVoucherCinemaSettings.forEach(
            (cinemaSetting, cinemaSettingIndex) => {
              const seatGroups = cinemaSetting.seat_group_id.map((seats) => {
                return Number(seats.sstg_id);
              });
              const ticketGroups = cinemaSetting.ticket_type_id.map(
                (tickets) => {
                  return Number(tickets.tt_id);
                }
              );
              const rateCardGroups = cinemaSetting.rc_g_id.map(
                (rateCardGroup) => {
                  return rateCardGroup.rc_g_id;
                }
              );

              cinemaSetting.cinema_id.forEach((cinema) => {
                const screensList = cinemaSetting.screen_id.filter((screen) => {
                  return (screen.cinema_id || screen.cine_id) == cinema.cine_id;
                });

                if (screensList.length) {
                  screensList.forEach((screen) => {
                    payload["cinemaSettings"].push({
                      dvcs_cinema_id: cinema.cine_id,
                      dvcs_screen_id: screen.screen_id,
                      dvcs_st_id: seatGroups || null,
                      dvcs_tt_id: ticketGroups || null,
                      dvcs_rc_g_id: rateCardGroups || null,
                      dvcs_index: cinemaSettingIndex,
                    });
                  });
                } else {
                  payload["cinemaSettings"].push({
                    dvcs_cinema_id: cinema.cine_id,
                    dvcs_screen_id: null,
                    dvcs_st_id: seatGroups || null,
                    dvcs_tt_id: ticketGroups || null,
                    dvcs_rc_g_id: rateCardGroups || null,
                    dvcs_index: cinemaSettingIndex,
                  });
                }
              });
            }
          );
        }

        if (this.dynamicVoucherMovieSettings.mf_id.length) {
          payload["dv_movie_formats"] =
            this.dynamicVoucherMovieSettings.mf_id.map((movieFormat) => {
              return movieFormat.mf_id;
            });
        }
        if (this.dynamicVoucherMovieSettings.md_id.length) {
          payload["movieSettings"] = this.dynamicVoucherMovieSettings.md_id.map(
            (movieDetails) => {
              return {
                dvms_md_id: Number(movieDetails["md_id"]),
                dvms_id: movieDetails["dvms_id"] || null,
              };
            }
          );
        }

        if (this.dynamicVoucherFnbSettings.cinema_id.length) {
          payload["dv_fnb_cinemas"] =
            this.dynamicVoucherFnbSettings.cinema_id.map((cinema) => {
              return Number(cinema.cine_id);
            });
        }
        if (this.dynamicVoucherFnbSettings.fnb_items.length) {
          payload["fnbSettings"] = this.dynamicVoucherFnbSettings.fnb_items.map(
            (item) => {
              return { dvfs_item_code: item.item_code };
            }
          );
        }

        console.log({ payload });

        if (
          !payload["fnbSettings"] &&
          !payload["movieSettings"].length &&
          !payload["dv_movie_formats"] &&
          !payload["cinemaSettings"].length
        ) {
          return this.$toasted.show(
            "Atleast one configuration required to generate voucher"
          );
        }
        // return;
        let response = { status: false };
        if (this.$route.params["dv_id"]) {
          response = await MarketingService.editDynamicVouchers({
            ...payload,
            dv_id: this.$route.params["dv_id"],
          });
        } else {
          response = await MarketingService.addDynamicVouchers(payload);
        }

        const { data } = response || {};

        if (!data.status) {
          if (data["errors"] && data["errors"].length > 0) {
            return this.$toasted.show(data["errors"][0].message);
          }
          return this.$toasted.show(data["message"] || "Insertion failed");
        }

        this.$toasted.show(data["message"]);
        this.$router.push(`/marketing/dynamic-vouchers`);
      } catch (error) {
        console.log(error);
      } finally {
        loader.hide();
      }
    },

    // edit api
    fetchDynamicVoucherDetails: async function (dvId) {
      let loader = this.$loading.show();

      try {
        const response = await MarketingService.fetchSpecificDynamicVoucher({
          dv_id: dvId,
        });

        const { data } = response;

        if (!data.status) {
          return this.$toasted.show("No data found");
        }

        Object.keys(this.dynamicVoucherSettings).forEach((dvKey) => {
          this.dynamicVoucherSettings[dvKey] = data["Records"][dvKey];
          if (
            dvKey == "dv_valid_from_show_date" &&
            data["Records"][dvKey] == "Y"
          ) {
            this.dynamicVoucherMetaData["validity"] = "show_date";
          }
        });

        console.log(this.dynamicVoucherSettings, "this.dynamicVoucherSettings");

        this.dynamicVoucherSettings["dv_validity_start_date"] = moment(
          data["Records"]["dv_validity_start"]
        ).format("YYYY-MM-DD");
        this.dynamicVoucherSettings["dv_validity_start_time"] = moment(
          data["Records"]["dv_validity_start"],
          "YYYY-MM-DD HH:mm"
        ).format("HH:mm");
        this.dynamicVoucherSettings["dv_validity_end_date"] = moment(
          data["Records"]["dv_validity_end"]
        ).format("YYYY-MM-DD");
        this.dynamicVoucherSettings["dv_validity_end_time"] = moment(
          data["Records"]["dv_validity_end"],
          "YYYY-MM-DD HH:mm"
        ).format("HH:mm");

        this.dynamicVoucherTermsConditions = this.decodeHtml(
          data["Records"]["dv_terms_conditions"]
        );

        this.dynamicVoucherSettings["dv_rule_id"] = this.masterRules.find(
          (rule) => {
            return rule.value == this.dynamicVoucherSettings["dv_rule_id"];
          }
        );

        if (data["Records"]["dv_redemptions"]) {
          const redemptionOutlets =
            data["Records"]["dv_redemptions"].split(",");
          this.dynamicVoucherSettings["dv_redemptions"] =
            this.masterRedemptionOutlets.filter((redemption) => {
              return redemptionOutlets.includes(String(redemption.user_id));
            });
        }
        if (data["Records"]["dv_os_id"]) {
          this.dynamicVoucherSettings.dv_os_id = this.validDynamicVouchers.find(
            (validVoucher) => {
              return validVoucher.os_id == data["Records"]["dv_os_id"];
            }
          );
        }
        if (data["Records"]["dv_fnb_cinemas"]) {
          const fnbCinemas = data["Records"]["dv_fnb_cinemas"].split(",");
          this.dynamicVoucherFnbSettings.cinema_id = this.masterCinemas.filter(
            (cinema) => {
              return fnbCinemas.includes(String(cinema.cine_id));
            }
          );
        }

        if (
          data["Records"]["movieDetails"] &&
          data["Records"]["movieDetails"].length
        ) {
          data["Records"]["movieDetails"].forEach((movieDetail) => {
            const movieDetailIndex = this.masterMovies.findIndex((movie) => {
              return movie.md_id == movieDetail.dvms_md_id;
            });

            if (movieDetailIndex >= 0) {
              this.dynamicVoucherMovieSettings["md_id"].push({
                ...this.masterMovies[movieDetailIndex],
                dvms_id: movieDetail.dvms_id,
              });
            }
          });
        }

        if (
          data["Records"]["dv_movie_formats"] &&
          data["Records"]["dv_movie_formats"].length
        ) {
          const movieFormats = data["Records"]["dv_movie_formats"].split(",");
          this.dynamicVoucherMovieSettings["mf_id"] = this.masterFormats.filter(
            (movieFormat) => {
              return movieFormats.includes(String(movieFormat.mf_id));
            }
          );
        }

        const selectedCinemas = [];
        if (
          data["Records"]["cinemaMovieSettings"] &&
          data["Records"]["cinemaMovieSettings"].length
        ) {
          data["Records"]["cinemaMovieSettings"].forEach((cmSetting) => {
            if (!this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index]) {
              this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index] = {
                cinemas: [],
                screens: [],
                rate_card_groups: [],
                rc_g_id: [],
                cinema_id: [],
                screen_id: [],
                seat_group_id: [],
                ticket_type_id: [],
                dvcs_id: null,
              };
            }

            this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index]["cinemas"] =
              this.masterCinemas;
            this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index]["screens"] =
              this.cinemaWiseScreens;
            this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index]["dvcs_id"] =
              cmSetting.dvcs_id;

            const currentCinema = this.masterCinemas.find((cinema) => {
              return cinema.cine_id == cmSetting.dvcs_cinema_id;
            });
            selectedCinemas.push(String(cmSetting.dvcs_cinema_id));

            if (currentCinema) {
              this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index][
                "cinema_id"
              ].push(currentCinema);
            }

            const currentScreen = this.masterScreens.find((screen) => {
              return screen.screen_id == cmSetting.dvcs_screen_id;
            });
            if (currentScreen) {
              this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index][
                "screen_id"
              ].push({
                cinema_id: currentScreen.cine_id,
                screen_id: currentScreen.screen_id,
                screen_name: currentScreen.screen_name,
              });
            }

            const rateCardGroups = cmSetting.dvcs_rc_g_id
              ? cmSetting.dvcs_rc_g_id.split(",")
              : [];

            if (rateCardGroups && rateCardGroups.length) {
              const currentRateCardCinema =
                this.cinemaWiseRateCardGroups[cmSetting.dvcs_cinema_id];
              this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index][
                "rate_card_groups"
              ].push(...currentRateCardCinema);
              this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index][
                "rc_g_id"
              ].push(
                ...currentRateCardCinema.filter((cinemaRateCard) => {
                  return rateCardGroups.includes(
                    String(cinemaRateCard.rc_g_id)
                  );
                })
              );
            }

            const seatGroups = cmSetting.dvcs_st_id
              ? cmSetting.dvcs_st_id.split(",")
              : [];

            if (seatGroups && seatGroups.length) {
              const currentSeatGroups = this.masterSeatGroups.filter((seat) => {
                return seatGroups.includes(String(seat.sstg_id));
              });
              if (currentSeatGroups.length) {
                this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index][
                  "seat_group_id"
                ] = currentSeatGroups;
              }
            }

            const ticketTypes = cmSetting.dvcs_tt_id
              ? cmSetting.dvcs_tt_id.split(",")
              : [];
            if (ticketTypes && ticketTypes.length) {
              const currentTicketTypes = this.masterTicketTypes.filter(
                (ticket) => {
                  return ticketTypes.includes(String(ticket.tt_id));
                }
              );
              if (currentTicketTypes.length) {
                this.dynamicVoucherCinemaSettings[cmSetting.dvcs_index][
                  "ticket_type_id"
                ] = currentTicketTypes;
              }
            }
          });
          this.dynamicVoucherCinemaSettings.forEach((cmSetting) => {
            const currentRowSelectedCinemas = cmSetting.cinema_id.map(
              (cinema) => {
                return String(cinema.cine_id);
              }
            );
            cmSetting["cinemas"] = this.masterCinemas.filter((cinema) => {
              return (
                !selectedCinemas.includes(String(cinema.cine_id)) ||
                currentRowSelectedCinemas.includes(String(cinema.cine_id))
              );
            });
            cmSetting["cinema_id"] = _.uniqBy(
              cmSetting["cinema_id"],
              "cine_id"
            );

            cmSetting["screens"] = cmSetting["screens"].filter((screen) => {
              return currentRowSelectedCinemas.includes(
                String(screen.cinema_id)
              );
            });
            cmSetting["scren_id"] = _.uniqBy(
              cmSetting["screen_id"],
              "screen_id"
            );
          });

          console.log(
            this.dynamicVoucherCinemaSettings,
            "this.dynamicVoucherCinemaSettings"
          );
        }

        if (
          data["Records"]["fnbSettings"] &&
          data["Records"]["fnbSettings"].length
        ) {
          data["Records"]["fnbSettings"].forEach((fnbItem) => {
            const currentFnbItem = this.masterFnbItems.find((item) => {
              return item.item_code == fnbItem.dvfs_item_code;
            });

            if (currentFnbItem) {
              this.dynamicVoucherFnbSettings["fnb_items"].push({
                fc_id: currentFnbItem.fc_id,
                fc_category: currentFnbItem.fc_category,
                item_code: currentFnbItem.item_code,
                item_name: currentFnbItem.item_name,
                dvfs_id: fnbItem.dvfs_id || null,
              });
            }
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style>
.cinema-settings .multiselect,
.cinema-settings .multiselect__tags,
.cinema-settings .multiselect__input,
.cinema-settings .multiselect__single {
  border: unset !important;
  border-radius: unset !important;
  box-shadow: none !important;
  /* padding-left: 0px !important; */
}

/*.cinema-settings .multiselect__tags-wrap,
.dynamic-voucher-layout .multiselect__tags-wrap {
    display: block
}*/

.dynamic-voucher-layout .multiselect,
.dynamic-voucher-layout .multiselect__tags,
.dynamic-voucher-layout .multiselect__input {
  min-height: 35px;
  /* padding-left: 2px !important; */
  font-size: 10px;
}

.dynamic-voucher-layout .input-material input {
  min-height: 35px;
  max-height: 35px;
}

.dynamic-voucher-layout .add-btn {
  background: transparent;
  border: unset;
}

.dynamic-voucher-layout label {
  font-size: 12px;
}

dynamic-voucher-layout .multiselect__tags {
  max-width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/addDynamicVouchers.vue